import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowLeftCircleFilled = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 34,
	height: 34,
	viewBox: "0 0 34 34",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_4851_1006y)",
		children: /* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M17 34C7.61116 34 8.20799e-07 26.3888 0 17C-8.20798e-07 7.61116 7.61116 8.20798e-07 17 0C26.3888 -8.20799e-07 34 7.61116 34 17C34 26.3888 26.3888 34 17 34ZM16.293 23.707C16.6835 24.0976 17.3165 24.0976 17.707 23.707C18.0976 23.3165 18.0976 22.6835 17.707 22.293L13.4141 18H23C23.5523 18 24 17.5523 24 17C24 16.4477 23.5523 16 23 16H13.4141L17.707 11.707C18.0976 11.3165 18.0976 10.6835 17.707 10.293C17.3165 9.90244 16.6835 9.90244 16.293 10.293L10.293 16.293C9.90244 16.6835 9.90244 17.3165 10.293 17.707L16.293 23.707Z",
			fill: "currentColor"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_4851_1006y",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 34,
			height: 34,
			fill: "white"
		})
	}) })]
});
const ForwardRef = forwardRef(SvgArrowLeftCircleFilled);
export { ForwardRef as ReactComponent };
